// extracted by mini-css-extract-plugin
export var active = "lcSidebarSubcategoryArticle-module--active--7640b";
export var link = "lcSidebarSubcategoryArticle-module--link--86732";